<template>
  <v-select
    label="İleti Türü"
    v-model="selectedType"
    :items="types"
    item-text="name"
    item-value="value"
    :rules="[(v) => v === 0 || !!v || 'Bir ileti türü seçin.']"
    @change="changeType"
    required
  ></v-select>
</template>

<script>
export default {
  data: () => ({
    types: [
      { name: "Bilgi", value: "bilgi" },
      { name: "Ticari", value: "ticari" },
    ],
    selectedType: null,
  }),
  methods: {
    changeType() {
      this.$emit("type", this.selectedType);
    },
  },
};
</script>